import { render } from "./AlzataConfirmInviteAccount.vue?vue&type=template&id=40bd8d5b"
import script from "./AlzataConfirmInviteAccount.vue?vue&type=script&lang=js"
export * from "./AlzataConfirmInviteAccount.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__